import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { ARMS } from "@/lib/constants";
import Reveal from "@/components/Reveal";

const Row = ({ k, v }) => (
  <div className="py-3 border-t border-slate-200">
    <dt className="text-[13px] font-bold text-slate-500">{k}</dt>
    <dd className="mt-1 text-[15px] leading-relaxed text-slate-700">{v}</dd>
  </div>
);

export default function ArmCards() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-testid="arm-cards">
      {ARMS.map((a, i) => {
        const cta = a.external ? (
          <a href={a.to} target="_blank" rel="noopener noreferrer" className="hp-link hp-arm-accent"
             aria-label={`${a.cta} (opens applykar.in in a new tab)`}>
            {a.cta} <ArrowUpRight className="w-4 h-4" aria-hidden="true" />
          </a>
        ) : (
          <Link to={a.to} className="hp-link hp-arm-accent">{a.cta} <ArrowRight className="arrow w-4 h-4" aria-hidden="true" /></Link>
        );
        return (
          <Reveal key={a.key} delay={i * 90}>
            <article data-arm={a.key} className="h-full bg-white border border-slate-200 rounded-md flex flex-col">
              <div className="hp-arm-bar h-1.5 rounded-t-md" />
              <div className="p-7 flex flex-col flex-1">
                <h3 className="hp-h3">{a.name}</h3>
                <p className="mt-1 text-[15px] font-bold hp-arm-accent">{a.descriptor}</p>
                <dl className="mt-5 flex-1">
                  <Row k="Problem solved" v={a.problem} />
                  <Row k="Capability" v={a.capability} />
                  <Row k="Outcome" v={a.outcome} />
                </dl>
                <div className="mt-5">{cta}</div>
              </div>
            </article>
          </Reveal>
        );
      })}
    </div>
  );
}
